import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export function PanelLayout({
  header,
  children,
  footer,
  className,
  bodyClassName,
  footerClassName,
}: {
  header?: ReactNode;
  children: ReactNode;
  footer: ReactNode;
  className?: string;
  bodyClassName?: string;
  footerClassName?: string;
}) {
  return (
    <div className={cn("flex min-h-0 min-w-0 flex-col gap-3 overflow-hidden", className)}>
      {header && <div className="shrink-0">{header}</div>}
      <div
        className={cn(
          "custom-scrollbar min-h-0 flex-1 overflow-y-auto overscroll-contain pr-2 [scrollbar-gutter:stable]",
          bodyClassName,
        )}
      >
        {children}
      </div>
      <div
        className={cn(
          "flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-neutral-200/60 bg-neutral-50/50 pt-2",
          footerClassName,
        )}
      >
        {footer}
      </div>
    </div>
  );
}
